/**
 * KAN-746: итоги заказа: Подытог, Доставка, Наценка (строки только если
 * пришли), Итого. Общие для карточки заказа и EstimateOrderView.
 * KAN-755: строки "Скидка -X" (если скидка есть) и "Промокод CODE".
 */
import { formatRubKopecks } from '@/lib/money';

export interface OrderTotalsValues {
  subtotal: number;
  /** null: строки нет. */
  delivery: number | null;
  /** null: строки нет. */
  markup: number | null;
  total: number;
  /** KAN-755: скидка заказа; null или нет: строки нет. */
  discount?: number | null;
  /** KAN-755: промокод заказа; нет: строки нет. */
  promoCode?: string | null;
}

export function OrderTotals({ subtotal, delivery, markup, total, discount, promoCode }: OrderTotalsValues) {
  return (
    <div className="space-y-2 border-t p-4" data-testid="order-totals">
      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">Подытог</span>
        <span data-testid="order-subtotal" className="text-gray-900">
          {formatRubKopecks(subtotal)}
        </span>
      </div>
      {discount !== null && discount !== undefined && discount > 0 && (
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Скидка</span>
          <span data-testid="order-discount" className="text-green-700">
            -{formatRubKopecks(discount)}
          </span>
        </div>
      )}
      {promoCode && (
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Промокод</span>
          <span data-testid="order-promo-code" className="font-mono text-gray-900">
            {promoCode}
          </span>
        </div>
      )}
      {delivery !== null && (
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Доставка</span>
          <span data-testid="order-delivery" className="text-gray-900">
            {formatRubKopecks(delivery)}
          </span>
        </div>
      )}
      {markup !== null && (
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Наценка</span>
          <span data-testid="order-markup" className="text-gray-900">
            {formatRubKopecks(markup)}
          </span>
        </div>
      )}
      <div className="flex items-center justify-between border-t pt-2">
        <span className="font-bold text-gray-900">Итого</span>
        <span data-testid="order-total" className="text-lg font-bold text-gray-900">
          {formatRubKopecks(total)}
        </span>
      </div>
    </div>
  );
}
